import { serviceImages } from "../assets/service/service";

export const serviceContentConfig = [
  {
    pageName: "web-app",
    title: "Build A Web App",
    content:
      "Reliable, fast, secure, and ultimately - amazing user experience. That’s what you look for when you want to create a web application. Build your application that works across different devices, while growing your business.",
    backgroundImage: serviceImages.webapp.hero,
    developer: "Web",
    projectCount: "10+",
    benefitsList: {
      title: "Why Choose A Web App Developer From Acube?",
      benefits: [
        "All developers are bound by strict confidentiality and privacy NDAs",
        "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
        "Our Android App developers are well-versed with Agile development methodology.",
        "Developers well versed in English communication and can integrate well into your team.",
        " A rigorous QA testing process to ensure your App will work across all Android devices.",
        "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      ],
    },
    service: {
      image: serviceImages.webapp.list,
      alt: "web-services",
    },
  },
  {
    pageName: "ai",
    title: "Artificial Intelligence",
    content:
      "Our team of developers are experienced with AI technology to meet your business needs. We offer smart AI / ML solutions that are cost-effective in nature and offer detailed insights that can help the business grow.",
    backgroundImage: serviceImages.ai.hero,
    developer: "Artificial Intelligence",
    projectCount: "10+",
    benefitsList: {
      title: "Why Choose An AI Developer From Acube?",
      benefits: [
        "All developers are bound by strict confidentiality and privacy NDAs",
        "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
        "Our Android App developers are well-versed with Agile development methodology.",
        "Developers well versed in English communication and can integrate well into your team.",
        "A rigorous QA testing process to ensure your App will work across all Android devices.",
        "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      ],
    },
    service: {
      image: serviceImages.ai.list,
      alt: "ai-services",
    },
  },
  {
    pageName: "blockchain-app",
    title: "Build Your Blockchain App",
    content:
      "Future-proof your business with the help of blockchain technology. Our specialists can create and implement digital solutions for organizations by securing information that is distributed publicly via the Internet without being copied or tampered.",
    backgroundImage: serviceImages.blockchain.hero,
    developer: "Blockchain",
    projectCount: "10+",
    benefitsList: {
      title: "Why Choose A Blockchain Developer From Acube?",
      benefits: [
        "All developers are bound by strict confidentiality and privacy NDAs",
        "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
        "Developers well versed in English communication and can integrate well into your team.",
        "A rigorous QA testing process to ensure your App will work across all Android devices.",
        "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      ],
    },
    service: {
      image: serviceImages.blockchain.list,
      alt: "blockchain-services",
    },
  },
  {
    pageName: "cloud",
    title: "Build Your Cloud Strategy & Development",
    content:
      "Cloud computing has seen increasing demand over the past several years and is defined as the delivery of business tools and applications such as databases, software, and servers across the internet. A lot of businesses are now adopting cloud computing because of its cost savings, flexibility, and ease of scalability.",
    backgroundImage: serviceImages.cloud.hero,
    developer: "Cloud",
    projectCount: "10+",
    benefitsList: {
      title: "Why Choose A Cloud Developer From Acube?",
      benefits: [
        "All developers are bound by strict confidentiality and privacy NDAs",
        "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
        "Developers well versed in English communication and can integrate well into your team.",
        "A rigorous QA testing process to ensure your App will work across all Android devices.",
        "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      ],
    },
    service: {
      image: serviceImages.cloud.list,
      alt: "cloud-services",
    },
  },
  {
    pageName: "robotic-automation",
    title: "Robotic Process Automation",
    content:
      "Increase productivity in your business and daily operations using Robotic Process Automation. Automate manual processes for any repetitive, rule-based, and high-volume jobs that you have. Hire an RPA developer to help you create human-like manual interaction, reduce human error and turn-around times, and even annual savings.",
    backgroundImage: serviceImages.robotic.hero,
    developer: "RPA",
    projectCount: "10+",
    benefitsList: {
      title: "Why Choose An RPA Developer From Acube?",
      benefits: [
        "All developers are bound by strict confidentiality and privacy NDAs",
        "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
        "Developers well versed in English communication and can integrate well into your team.",
        "A rigorous QA testing process to ensure your App will work across all Android devices.",
        "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      ],
    },
    service: {
      image: serviceImages.robotic.list,
      alt: "robotic-services",
    },
  },
  {
    pageName: "business-intelligence",
    title: " Business Intelligence",
    content:
      "Shorten your systems development life cycle and deliver high-quality software. Get end-to-end automation for shorter time-to-market, resulting in faster product release using our robust infrastructure. Our team ensures agile delivery by reducing iterations, anticipating problems, and ensuring smooth execution throughout the process.",
    backgroundImage: serviceImages.devops.hero,
    developer: "Business Intelligence",
    projectCount: "10+",
    benefitsList: {
      title: "Why Choose A Business Intelligence Professional From Acube?",
      benefits: [
        "All developers are bound by strict confidentiality and privacy NDAs",
        "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
        "Developers well versed in English communication and can integrate well into your team.",
        "A rigorous QA testing process to ensure your App will work across all Android devices.",
        "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      ],
    },
    service: {
      image: serviceImages.devops.list,
      alt: "business-intelligence",
    },
  },
  {
    pageName: "ios-app",
    title: "Build Your IOS App",
    content:
      "Create iOS apps that people actually use and love. There are many reasons why you would want to build your app on the iOS platform.",
    backgroundImage: serviceImages.ios.hero,
    projectCount: "10+",
    alt: "ios-banner",
    developer: "IOS",
    benefitsList: {
      title: "Why Choose An IOS Developer From Acube?",
      benefits: [
        "All ‘Swift-proficient’ developers.",
        "All developers are bound by strict confidentiality and privacy NDAs",
        "Our iOS app makers are well-versed with Agile development methodology.",
        "Developers well versed in English communication and can integrate well into your team",
        "An iOS developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
        "A rigorous QA testing process to ensure your App will work across all Apple devices. Something you will not get when you hire a freelancer.",
      ],
    },
    service: {
      image: serviceImages.ios.list,
      alt: "ios",
    },
  },
  {
    pageName: "android-app",
    title: "Build An Android App",
    content:
      "Android App development has become essential for every business. With more than 84% of mobile users globally on Android and a wide range of customization options, our developers can help turn your ideas into reality.",
    backgroundImage: serviceImages.android.hero,
    developer: "Android",
    projectCount: "10+",
    benefitsList: {
      title: "Why Choose An Android Developer From Acube?",
      benefits: [
        "All developers are bound by strict confidentiality and privacy NDAs",
        "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
        "Our Android App developers are well-versed with Agile development methodology.",
        "Developers well versed in English communication and can integrate well into your team.",
        " A rigorous QA testing process to ensure your App will work across all Android devices.",
        "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      ],
    },
    service: {
      image: serviceImages.android.list,
      alt: "android",
    },
  },
  {
    pageName: "ml-developer",
    title: "Machine Learning",
    content:
      "Shorten your systems development life cycle and deliver high quality software. Get end-to-end automation for shorter time-to-market, resulting in faster product release using our robust infrastructure. Our team ensures agile delivery by reducing iterations, anticipating problems, and ensuring smooth execution throughout the process.",
    backgroundImage: serviceImages.ml.hero,
    developer: "Machine Learning",
    projectCount: "10+",
    benefitsList: {
      title: "Why Choose A Machine Learning Professional From Acube?",
      benefits: [
        "All developers are bound by strict confidentiality and privacy NDAs",
        "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
        "Our Android App developers are well-versed with Agile development methodology.",
        "Developers well versed in English communication and can integrate well into your team.",
        " A rigorous QA testing process to ensure your App will work across all Android devices.",
        "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      ],
    },
    service: {
      image: serviceImages.ml.list,
      alt: "android",
    },
  },
  {
    pageName: "iot-app",
    title: "Internet Of Things (IoT)",
    content:
      "Shorten your systems development life cycle and deliver high quality software. Get end-to-end automation for shorter time-to-market, resulting in faster product release using our robust infrastructure. Our team ensures agile delivery by reducing iterations, anticipating problems, and ensuring smooth execution throughout the process.",
    backgroundImage: serviceImages.iot.hero,
    developer: "IOT",
    projectCount: "10+",
    benefitsList: {
      title: "Why Choose An IoT Professional From Acube?",
      benefits: [
        "All developers are bound by strict confidentiality and privacy NDAs",
        "State-of-the-art infrastructure with secure firewalls and IP protection systems.",
        "Our Android App developers are well-versed with Agile development methodology.",
        "Developers well versed in English communication and can integrate well into your team.",
        " A rigorous QA testing process to ensure your App will work across all Android devices.",
        "A developer assigned to you is solely dedicated to your project. This ensures the highest quality delivered to you.",
      ],
    },
    service: {
      image: serviceImages.iot.list,
      alt: "android",
    },
  },
];

export const serviceUrlRouting = [
  {
    pathname: "/services/artificial_intelligence",
    pageName: "ai",
  },
  {
    pathname: "/services/web_app",
    pageName: "web-app",
  },
  {
    pathname: "/services/blockchain_app",
    pageName: "blockchain-app",
  },
  {
    pathname: "/services/cloud_strategy",
    pageName: "cloud",
  },
  {
    pathname: "/services/robotic_process_automation",
    pageName: "robotic-automation",
  },
  {
    pathname: "/services/machine_learning",
    pageName: "ml-developer",
  },
  {
    pathname: "/services/iot_app",
    pageName: "iot-app",
  },
  {
    pathname: "/services/android_app",
    pageName: "android-app",
  },
  {
    pathname: "/services/business_intelligence",
    pageName: "business-intelligence",
  },
  {
    pathname: "/services/ios_app",
    pageName: "ios-app",
  },
];
